import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Leftside from "../Landing_page/Left_sidebar/Leftside"


import { Home } from "./front_middle_page/real"
import styles from './Homepage.module.css'

export const HomePage = () => {
    const currentProfile = useSelector(state => state.currentProfile);
    const loggedInUser = useSelector(state => state.loggedInUser);
    const loggedIn = useSelector(state => state.loggedIn);
    const history = useHistory();
    useEffect(() => {
        if (loggedIn) {
            history.push("/homepage");
        }
    }, [])

    return(
        <div style={{ background:"rgba(245,247,250,1)"}}>
            <div className={styles.homepage}>
                <div >
                    <Leftside />
                </div>
                    <div style={{minWidth:"270px", border:"1px solod red"}}></div>
                <Home />

            </div>
     </div>
    )
}